// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_equal--line"><path id="Union" d="M36 31H12V27H36V31ZM36 20H12V16H36V20Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_equal--line"><path id="Union" d="M36 31H12V27H36V31ZM36 20H12V16H36V20Z" style="fill: currentColor"/></g></svg>`;

export const Equal: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
